module.exports = __webpack_public_path__ + "img/reset-password.9edb07ab.png";